module.exports = __webpack_public_path__ + "img/quiz.35c64bb4.png";